import { Outlet } from 'react-router';
import { mergeMeta } from '~/utils/mergeMeta'

export const meta = mergeMeta(
  () => [{ title: 'Heja | Download' }],
  () => [{ name: 'robots', content: 'noindex' }]
)

export default function DownloadLayout() {
  return <Outlet />
}
